<div class="page-content page-fill">
  @if (!data) {
    <div>No Documents Found</div>
  }
  <!-- <button class="mt-3 ms-4 btn btn-success" (click)="getData()">Get Data</button>
  <button class="mt-3 ms-4 btn btn-success" (click)="linkClicked()">Link Clicked</button>
  <div *ngIf="data" class="card-body">
    <div class="m-3">
      <h2>Code {{ data.code }}</h2>
    </div>
  </div> -->

  @if (data && data.length > 0) {
    <div>
      @for (package of data; track package) {
        <div>
          <div class="card-body"  style="border: 1px solid #ccc; border-radius: 5px; padding: 10px; margin-top: 10px;">
            <h3>Document Package {{ package.PackageNumber }} -- Sent on: {{ package.Sent | date }}</h3>
            <table class="table mt-3">
              <thead>
                <tr>
                  <th>Name</th>
                  <!-- <th>File</th> -->
                </tr>
              </thead>
              <tbody>
                @for (review of package.Reviews; track review) {
                  <tr>
                    <td class="col-xs-5">
                      <a href="javascript:void(0)" (click)="openReview(review.Id)" style="cursor: pointer; color: #007bff; text-decoration: underline;">{{ review.Name }}</a>
                    </td>
                    <!-- <td class="col-xs-5">{{ review.Filename }}</td> -->
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }
    </div>
  }

  <!-- <div class="m-3">
  <h2>
    Proposal
    <h3>From: {{ proposalInfo.FromCommittee }} To: {{ proposalInfo.ToCommittee }}</h3>
  </h2>
  <div class="m-3" style="max-width: 850px" *ngIf="proposalInfo">
    <strong> {{ proposalInfo.Message }}</strong>
    <div *ngIf="proposalInfo && proposalInfo.Notes">Notes: {{ proposalInfo.Notes }}</div>
  </div>
</div> -->
<!-- <button class="mt-3 ms-4 btn btn-success {{ proposalInfo.Voted && proposalInfo.YesVote ? ' border-class' : '' }}" (click)="submitVote('Yes')" [hidden]="voteClosed">
Vote Yes
</button>
<button class="mt-3 ms-4 btn btn-danger {{ proposalInfo.Voted && !proposalInfo.YesVote ? ' border-class' : '' }}" (click)="submitVote('No')" [hidden]="voteClosed">
  Vote No
</button>

<div *ngIf="proposalInfo && proposalInfo.Voted" class="m-3">You voted {{ proposalInfo.YesVote ? "YES" : "NO" }} on {{ proposalInfo.voteDate }}</div>

<div *ngIf="proposalInfo && canDiscuss" class="m-3" style="max-width: 100%">
  Discussion
  <dx-text-area [(value)]="discussion" [height]="'100px'"></dx-text-area>
</div>
<button class="ms-3 btn btn-primary" (click)="addDiscussion()" [hidden]="!canDiscuss || voteClosed">Add Discussion</button>

<div *ngIf="proposalInfo && discussions.length > 0">
  <table class="table mt-3">
    <thead>
      <tr>
        <th>Name</th>
        <th>Note</th>
        <th>Date</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let note of discussions">
        <td class="col-xs-5">{{ note.Name }}</td>
        <td class="col-xs-5">{{ note.Note }}</td>
        <td class="col-xs-1">{{ note.date }}</td>
      </tr>
    </tbody>
  </table>
</div> -->

<!-- <div *ngIf="proposalInfo && proposalInfo.Voted" class="m-3">
<h3>Thanks for voting!</h3>
</div>
<div *ngIf="proposalInfo && (proposalInfo.Approved || proposalInfo.Declined || proposalInfo.Voted)" class="m-3">
  <h3>The motion{{ proposalInfo.Approved ? " was APPROVED" : proposalInfo.Declined ? " was DECLINED" : " is still open for voting" }}</h3>
</div> -->
</div>
